import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Target, Heart, Zap, Shield, Users, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import { coreValues, ministryLinks, publicCtas } from '@/content/public-site-content';

const iconMap: Record<string, React.ElementType> = {
  Target,
  Heart,
  Zap,
  Shield,
  Users,
  Globe,
};

export default function CoreValuesPage() {
  return (
    <div className="max-w-6xl mx-auto w-full p-6 space-y-8">
      <div className="text-center space-y-4">
        <Badge variant="outline" className="mb-2">
          <Target className="mr-1 h-3 w-3" />
          Ministry
        </Badge>
        <h1 className="text-4xl font-bold">Core Values</h1>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
          The values that shape who we are and guide everything we do at Dominion Mandate
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {coreValues.map((value) => {
          const Icon = iconMap[value.icon] || Target;
          return (
            <Card key={value.title} className="border-border/70 bg-card/90 shadow-sm">
              <CardHeader>
                <Icon className="h-8 w-8 text-primary mb-2" />
                <CardTitle className="text-xl">{value.title}</CardTitle>
                <CardDescription className="text-sm leading-6">
                  {value.description}
                </CardDescription>
              </CardHeader>
            </Card>
          );
        })}
      </div>

      <Card className="bg-primary/5 border-primary/20">
        <CardContent className="p-8 text-center">
          <h2 className="text-xl font-bold mb-2">Explore More</h2>
          <p className="text-muted-foreground mb-6">
            Learn about our ministry, visit the broadcast, or reach out directly.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {ministryLinks.filter(l => l.label !== 'Core Values').map((link) => (
              <Link key={link.href} to={link.href}>
                <Badge variant="outline" className="text-sm px-4 py-2 cursor-pointer hover:bg-primary/10">
                  {link.label}
                </Badge>
              </Link>
            ))}
            {publicCtas.slice(0, 3).map((cta) => (
              <Link key={cta.href} to={cta.href}>
                <Button variant={cta.href === '/media' ? 'default' : 'outline'}>
                  {cta.label}
                </Button>
              </Link>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
